import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { setVersion as setVersionAction } from '@src/store/ui/actions';
import { versionSelector } from '@src/store/ui/selectors';

import useLogout from './useLogout';

const useCheckVersion = () => {
  const version = useSelector(versionSelector);
  const logout = useLogout();
  const dispatch = useDispatch();

  React.useEffect(() => {
    if (version === undefined) {
      dispatch(setVersionAction(0));
      logout();
    }
  }, [dispatch, logout, version]);
};

export default useCheckVersion;
